<script lang="ts" setup>
import Biography from '~/pages/composer/[slug]/biography.vue'
import Media from '~/pages/media/[slug].vue'
let { slug } = useResourceSlug()
const url = useRequestURL()
</script>
<template>
  <Media v-if="url.host.includes('medias.ircam')" :slug="slug" />
  <Biography v-else :slug="slug" />
</template>
